import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
} from '@angular/router';
import { Observable, of, EMPTY, mergeMap, take } from 'rxjs';
import { PubSearchService } from '../services/pub-search.service';
import { AdamsDocModel } from '../models/adams-doc-model';
import { MessageService } from 'primeng/api';
import { SearchResultsModel } from '../models/search-results-model';

@Injectable({
  providedIn: 'root'
})
export class PropertyViewResolverService implements Resolve<AdamsDocModel> {
  constructor(private searchSvc: PubSearchService, private messageSvc: MessageService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const qData = route.paramMap.get('id');

    if (qData) {
      return this.searchSvc.getDocDetails(qData).pipe(
        take(1),
        mergeMap((e: SearchResultsModel) => {
          if (e) {
            return of(e.document);
          } else {
            return EMPTY;
          }
        })
      );
    }
    else {
      this.messageSvc.add({ summary: 'There was an error retrieving results!', severity: "error", detail: "No Query was sent!" })
      return EMPTY;
    }
  }
}
